import styled from "@emotion/styled";

import Well from "shared/components/Well";

export const StyledWell = styled(Well)`
  padding: 32px;
`;
